import React, { Component } from 'react'
import { BasicHeader } from '../../components/basic_header'
import { RESTExecutor, withDomains } from '../../lib/domain'
import ErrorWrapper from '../../lib/error_wrapper';
import { Table, notification, Select } from 'antd';
import NotificationItem from '../../components/notification_item';
import { PopUpForm } from '../../lib/ui/popupform';
import { showErrorInNotification, schema_to_field, formatMoney } from '../../lib/util';
import lodash from 'lodash';
import FilterFixedInput from '../../components/filter_fixed_input';

const queryString = require('query-string');


const notification_type = ["SUCCESS","ERROR","INFO","ALERT"]

class NotificationList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filter_query: {
        per_page: 100,
        page: 1
      },
      selected_notification: {},
      selected_item: {},
      form_data: {},
      form_schema: [],
      form_visibility: false

    }

    this.mark_seen = RESTExecutor.patch().config({
      label: 'update'
    }).callbacks((success) => {
      try {
        window.header.refreshNotifiicationCount(100);
      } catch (e) {
        console.log("failed", e)
      }
    }).connect(props.domains.notification);

    this.delete_notification = RESTExecutor.delete().config({
      label: 'update'
    }).callbacks((success) => {
      this.list_notifications.execute();
    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.notification);


    this.list_notifications = RESTExecutor.list().config({
      label: 'list'
    }).callbacks((success) => {
      let unseen_data = [];
      unseen_data = lodash.filter(success.result, ['seen', false]);
      console.log("seend ids", unseen_data)
      let unseen_ids = lodash.map(unseen_data, 'id');
      // console.log("seend ids",JSON.stringify(unseen_ids))
      if (unseen_ids.length > 0) {
        this.mark_seen.execute({
          ids: unseen_ids
        })
      }


    }).connect(props.domains.notification);



    this.act_to_notification = RESTExecutor.post().config({
      label: 'trigger'
    }).callbacks((success) => {

      notification.success({
        message: "Action Triggered"
      })
      this.list_notifications.execute()
      this.setState({
        form_visibility: false,
        form_schema: [],
        form_data: {},
        selected_notification: {},
        selected_item: {},
      })
    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.notification);

  }

  triggerNotification = (data) => {
    this.act_to_notification.execute({
      notification_id: this.state.selected_notification.id,
      id: this.state.selected_item.id,
      params: data
    })
  }



  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  render() {
    let list_notifications_resp = this.list_notifications.response();
    let delete_notification_resp=this.delete_notification.response();
    let act_to_notification_resp = this.act_to_notification.response();
    let rowsData = list_notifications_resp.result || [];
    let rowsMeta = list_notifications_resp.meta || {};

    const { form_data, form_schema, form_visibility, filter_query } = this.state;


    return (
      <div>
        <PopUpForm
          width="60%"
          key={`${this.state.selected_notification.id}upload`}
          title={`Required Information`}
          show_title_only
          forCreate={true}
          initialData={form_data}
          fields={form_schema}
          open={form_visibility}
          networkState={act_to_notification_resp}
          onClose={() => {
            console.log("closing upload form")
            this.setState({
              form_visibility: false,
              form_schema: [],
              form_data: {},
              selected_notification: {}
            })
          }
          }
          onSubmit={(data) => {
            console.log("DATA", data);
            this.triggerNotification(data);
          }}
        />
        <BasicHeader title="Notifications" />

        <div className='filter-card'>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'space-between',
            flexWrap: 'wrap',
            paddingTop: 4, paddingBottom: 4
          }}>

            <FilterFixedInput label="Type">
              <Select
                placeholder="Select Notification Type"
                style={{
                }}
                value={filter_query.type}
                className={filter_query.type != null ? 'filter-option-selected' : ''}
                onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'type',
                    value: value,
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                      })
                      // this.list_logs.config({
                      //   params: {
                      //     ...this.getParams(),
                      //     page:1
                      //   }
                      // }).execute()
                    }
                  })
                }}
                allowClear
              >
                {notification_type.map((item) => {
                  return <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                })}

              </Select>
            </FilterFixedInput>
          </div>
        </div>



        <ErrorWrapper error={list_notifications_resp} onReload={() => {
          this.list_notifications.execute();
        }}>
          <div style={{
            marginLeft:8
          }}>
          <Table
            loading={list_notifications_resp.fetching||delete_notification_resp.fetching}
            dataSource={rowsData}
            showHeader={false}
            rowKey={(record) => `${record.id}`}
            className='noHover no-separator-table single-column no-padding-table'
            columns={[
              {
                dataIndex: '',
                render: (data) => {
                  return <NotificationItem
                    key={data.id}
                    data={data}
                    onDelete={(id) => {
                      this.delete_notification.execute({
                        ids: [id]
                      })
                    }}
                    onMark={(id)=>{
                      this.mark_seen.execute({
                        marked: [id],
                        ids:[id]
                      })
                    }}
                    onTriggerAction={(action_item, data) => {
                      console.log("trigger for", data)
                      this.setState({
                        selected_notification: data,
                        form_visibility: true,
                        selected_item: action_item,
                        form_data: {},
                        form_schema: schema_to_field(action_item.params)
                      })
                    }}
                  />
                }

              }
            ]}
            pagination={{
              simple: false,
              size: 'small',
              position: 'bottom',
              onChange: (current, size) => {
                this.props.history.push({
                  search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                })
              },
              defaultCurrent: 1,
              current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
              pageSize: (rowsMeta && rowsMeta.requested_count),
              total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
              showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count,0)} items`
            }}
          />
          </div>

        </ErrorWrapper>

      </div>
    )
  }

  componentDidMount() {

    //     try{
    //         window.header.refreshNotifiicationCount(3000);
    //         }catch(e){
    // console.log("failed",e)
    //     }
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.list_notifications.config({
        params: {
          ...this.state.filter_query
        }
      }).execute()
    })
  }
  componentWillReceiveProps(nextProps) {

    let new_filter_query = {};
    if ((this.props.location.search !== nextProps.location.search)) {
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query = parsed;
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...new_filter_query
        }
      }, () => {
        this.list_notifications.config({
          params: {
            ...this.state.filter_query
          }
        }).execute()
      })
    } else {
      //   this.list_logs.execute()
    }


  }

}

export default withDomains(NotificationList, "notification")
